export default __webpack_public_path__ + "static/media/GoldCard.454b1bf9.png";